import { createContext } from "react";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const company = {
    name: "Aranya Nutraceuticals ",
    phone: "+91 8884742478",
    phone2:"+91 8884744258",
    email:"info@aranyanutraceuticals.com",
    adress:"Holanagadde, Kumta,Uttara Kannada, Karnataka, 581351"
  };

  return (
    <AppContext.Provider value={{ company }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;